<template>
  <div v-if="isStayBundle || isOneFlavor || isOneFlavorBuybox" class="buybox__bundle__subscription subscription__options-container">
    <div class="subscription__options">
      <div v-if="hasMultiPack || hasSubscription" class="subscription__purchase" :data-selected="isSubscription" data-buying-option="subscription">
        <div class="subscription__input-heading caption caps-sm">
          Save {{ optionDiscountPercentage }}%
        </div>
        <div class="subscription__input" 
          :data-discount-type="selectedSellingPlan?.discount_type ?? null"
          :data-discount-value="selectedSellingPlan?.discount_value ?? null"
          >
          <label>
            <div class="subscription__input-label">
              <div class="subscription__input-left">
                <div class="subscription__input-title-wrapper">
                  <input type="radio" class="hide" :checked="isSubscription" @change="onSubscriptionChange(true)">

                  <svg v-if="!isSubscription" class="subscription-radio"><use href="#checkbox-empty"></use></svg>
                  <svg v-else class="subscription-radio"><use href="#checkbox-filled"></use></svg>

                  <span class="subscription__input-title" :class="{'is--bold': isSubscription}">Subscribe</span>
                </div>
                <div class="subscription__input-price-wrapper">
                  <div class="subscription__input-price text-bold">
                    {{ !isStayBundle ? subscriptionPrice : '' }} 
                  </div>
                  <div class="subscription__input-compare-price otp__input-price text-sm">
                    {{ !isStayBundle ? (compareAtPrice ? compareAtPrice : onetimePrice) : '' }}
                  </div>
                </div>
              </div>
              <div v-if="isBuyBoxChip" class="subscription__input-right">
                <div class="subscription__input-badge text-xs mobile-text-xs text-center" :style=" { '--bg-tag': isBuyBoxChip.color }">{{ isBuyBoxChip.name }}</div>
              </div>
            </div>
          </label>
        </div>
        <div v-if="isMultiPack && isSubscription" class="subscription__product-options">
          <template v-for="(option, optionIndex) in multipackOptions" :key="optionIndex">
            <div class="subscription__product-option">
              <div 
                v-for="(value, index) in option.values"
                :key="index"
                class="subscription__product-option-inner"
                @click="onSubscriptionOptionChange(option.name, value, (option.position-1))"
              >
                <div :class="['option-chip', { 'selected': option.selected === value }]">
                  <span class="text-base mobile-text-sm">{{ value }}</span>
                  <div class="option__price text-sm mobile-text-xs">
                    {{ getOptionUnitPrice(value) }} each
                  </div>
                </div>
                <div v-if="multipackOptionTag(option.position,value)" class="subscription__product-option-tag">
                  {{ multipackOptionTag(option.position,value) }}
                </div>
              </div>
            </div>
          </template>
        </div>        
        <div v-if="isSubscription" class="subscription__frequency-container">
          <div :class="['subscription__frequency-drpdwn' , {'open': isFrequencyDrpdwnOpen}]" @click="toggleFrequencyDrpdwn">
            <div class="subscription__frequency-drpdwn-selected" :data-discount-type="selectedSellingPlan.discount_type" :data-discount-value="selectedSellingPlan.discount_value">
              <svg class="icon icon--sm"><use href="#subscribe"></use></svg>
              {{ isFrequencyDrpdwnOpen ? '' :selectedSellingPlan.name }}
            </div>
            <svg class="subscription__frequency-drpdwn-arrow"><use href="#caret-down"></use></svg>
            <div v-if="isFrequencyDrpdwnOpen" class="subscription__frequency-drpdwn-options">
              <div
                v-for="option in renderSubFrequency" 
                :key="option.id" 
                :class="['subscription__frequency-drpdwn-option', {'selected': selectedSellingPlan.name === option.name}]" 
                @click="emit('update-selling-plan',option, true)"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="isSubscription && product.announcements_bundle_subscription && product.announcements_bundle_subscription.items.length" class="subscription__announcements">
          <div v-for="announcement in product.announcements_bundle_subscription.items" class="subscription__announcement flex flex--align-center">
            <svg class="buybox__announcement-icon">
              <use href="#check-contained-filled"></use>
            </svg>
            <span class="buybox__announcement-text">{{ announcement }}</span>
          </div>
        </div>
      </div>
      <div class="buybox__otp-container otp__input" :data-selected="!isSubscription" data-buying-option="onetime" :data-otp-discount-value="otpDiscountValue">
        <label>
          <div class="otp__input-label">
            <div class="subscription__input-left">
              <div class="subscription__input-title-wrapper">
                <input type="radio" class="hide" :checked="!isSubscription" @change="onSubscriptionChange(false)">

                <svg v-if="!isSubscription" class="subscription-radio"><use href="#checkbox-filled"></use></svg>
                <svg v-else class="subscription-radio"><use href="#checkbox-empty"></use></svg>

                <div class="otp__input-title" :class="{'is--bold': !isSubscription}">One time purchase</div>
              </div>
              <div class="subscription__input-price-wrapper">
                <div class="otp__input-price-discounted text-bold">
                  {{ !isStayBundle ? (onetimePrice ) : '' }}
                </div>
                <div v-if="otpDiscountValue" class="otp__input-price subscription__input-compare-price text-sm">{{ !isStayBundle ? onetimePrice : '' }}</div>
                <div v-else-if="!isStayBundle && compareAtPrice" class="subscription__input-compare-price otp__input-price text-sm">
                    {{ compareAtPrice }}
                  </div>
              </div>
            </div>
            <div v-if="isStayBundle" class="subscription__input-right">
              <div v-if="otpDiscountValue" class="otp__input-badge text-xs">
                Save {{ otpDiscountValue }}%
              </div>
            </div>
          </div>
        </label>
        <div v-if="!isSubscription && otpFreeShippingMessage" class="subscription__announcements">
          <div class="subscription__announcement flex flex--align-center">
            <svg class="buybox__announcement-icon">
              <use href="#check-contained-filled"></use>
            </svg>
            <span class="buybox__announcement-text" v-html="otpFreeShippingMessage"></span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-else class="subscription__options-container">
    <div class="option-group_label text-base mobile-text-sm">Frequency</div>
    
    <div class="subscription__options">
      <div v-if="hasMultiPack || hasSubscription" class="subscription__purchase">
        <div class="subscription__input">
          <label>
            <input type="radio" class="hide" :checked="isSubscription" @change="onSubscriptionChange(true)">

            <svg v-if="!isSubscription" class="subscription-radio"><use href="#checkbox-empty"></use></svg>
            <svg v-else class="subscription-radio"><use href="#checkbox-filled"></use></svg>

            <div class="subscription__input-label">
              <div class="subscription__input-left">
                <span class="subscription__input-title text-base" :class="{'is--bold': isSubscription}">Subscribe</span>
                <div class="subscription__input-badge text-sm mobile-text-xs">
                  Save {{ optionDiscountPercentage }}%
                </div>
              </div>
              <div class="subscription__input-right">
                <div class="text-lg mobile-text-base subscription__input-compare-price otp__input-price">
                  {{ !isStayBundle ? (compareAtPrice ? compareAtPrice : onetimePrice) : '' }}
                </div>
                <div class="text-lg mobile-text-base subscription__input-price">
                  {{ !isStayBundle ? subscriptionPrice : '' }} 
                </div>
              </div>
            </div>
          </label>
        </div>
        <div v-if="isMultiPack && isSubscription" class="subscription__product-options">
          <template v-for="(option, optionIndex) in multipackOptions" :key="optionIndex">
            <div class="subscription__product-option">
              <div 
                v-for="(value, index) in option.values"
                :key="index"
                class="subscription__product-option-inner"
                @click="onSubscriptionOptionChange(option.name, value, (option.position-1))"
              >
                <div :class="['option-chip', { 'selected': option.selected === value }]">
                  <span class="text-base mobile-text-sm">{{ value }}</span>
                  <div class="option__price text-sm mobile-text-xs">
                    {{ getOptionUnitPrice(value) }} each
                  </div>
                </div>
                <div v-if="multipackOptionTag(option.position,value)" class="subscription__product-option-tag">
                  {{ multipackOptionTag(option.position,value) }}
                </div>
              </div>
            </div>
          </template>
        </div>        
        <div v-if="isSubscription" class="subscription__frequency-container">
          <div class="subscription__frequency-title">
            <svg class="subscription__frequency-icon">
              <use href="#subscribe"></use>
            </svg>
            Delivered every:
          </div>
          <div :class="['subscription__frequency-drpdwn' , {'open': isFrequencyDrpdwnOpen}]" @click="toggleFrequencyDrpdwn">
            <div class="subscription__frequency-drpdwn-selected" :data-discount-type="selectedSellingPlan.discount_type" :data-discount-value="selectedSellingPlan.discount_value">
              <svg class="icon icon--sm"><use href="#subscribe"></use></svg>
              {{ isFrequencyDrpdwnOpen ? '' :selectedSellingPlan.name }}
            </div>
            <svg class="subscription__frequency-drpdwn-arrow"><use href="#caret-down"></use></svg>
            <div class="subscription__frequency-drpdwn-options" v-if="isFrequencyDrpdwnOpen">
              <div
                v-for="option in renderSubFrequency" 
                :key="option.id" 
                :class="['subscription__frequency-drpdwn-option', {'selected': selectedSellingPlan.name === option.name}]" 
                @click="emit('update-selling-plan',option, true)"
              >
                {{ option.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="buybox__otp-container otp__input">
        <label>
          <input type="radio" class="hide" :checked="!isSubscription" @change="onSubscriptionChange(false)">
          <div class="otp__input-label">
            <div class="otp__input-title" :class="{'is--bold': !isSubscription}">
              One time purchase
            </div>
            <div class="otp__input-price text-lg mobile-text-base">{{ !isStayBundle ? onetimePrice : '' }}</div>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { toRefs, ref, onMounted, computed } from 'vue';

  const props = defineProps({
    product: {
      type: Object,
      required: true,
    },

    selectedVariant: {
      type: Object,
      default: null,
    },

    isMultiPack: {
      type: Boolean,
      default: false
    },

    isSubscriptionProp: {
      type: Boolean,
      default: true
    },

    selectedSellingPlan: {
      type: Object,
      default: null
    },

    isStayBundle: {
      type: Boolean,
      default: false, 
    },

    isOneFlavor: {
      type: Boolean,
      default: false, 
    },

    isOneFlavorBuybox: {
      type: Boolean,
      default: false, 
    }
  })
  
  const { product, selectedVariant, isMultiPack, isSubscriptionProp, selectedSellingPlan, isStayBundle } = toRefs(props);
  var isSubscription = ref(false);
  const isFrequencyDrpdwnOpen = ref(false);

  const emit = defineEmits(['update-option','update-selling-plan','update-is-subscription']);

  onMounted(() => {
    if(hasSubscription.value && isSubscriptionProp.value){
      isSubscription.value = true;
    }
  })

  const isFeatureTag = computed(() => {
    return selectedVariant.value.feature_tag;
  })

  const isBuyBoxChip = computed(() => {
    return selectedVariant.value.buy_box_chip;
  })

  const hasMultiPack = computed(() => {
    const { variants } = product.value;
    const { options } = selectedVariant.value;

    const filterVariants = () => {
      if (options.length === 3) {
        return variants.filter(variant =>
          variant.options[0] === options[0] &&
          variant.options[1] === options[1]
        );
      } else if (options.length === 2) {
        return variants.filter(variant =>
          variant.options[0] === options[0]
        );
      }
      return [];
    };

    const hasAvailableVariants = filterVariants();
    return hasAvailableVariants.length > 1 && isMultiPack.value;
  });

  const hasSubscription = computed(() => {
    const { has_subscription} = product.value;
    const { has_subscription_plan } = selectedVariant.value;

    return has_subscription && has_subscription_plan
  })

  const optionDiscountPercentage = computed(() => {
    
    if (!isSubscription.value) {
      const availableSubscriptionVariant = subscriptionVariants();
      if (availableSubscriptionVariant) {
        return getDiscountPercentage(availableSubscriptionVariant);
      } else {
        return 0;
      }
    } else {
      return getDiscountPercentage(selectedVariant.value);
    }
  })

  const otpDiscountValue = computed(() => {
    if (isStayBundle.value) {
      // Hardcoded bundle_one_time_purchase_discount
      return 15;
    } else {
      return null;
    }
  })

  const otpFreeShippingMessage = computed(() => {
    if (!product) {
      return null;
    }
    const announcementsDefault = product.value.announcements_default;

    return announcementsDefault && typeof announcementsDefault === 'object' 
      ? announcementsDefault.free_shipping_otp ?? null 
      : null;
  })
  

  /*-- Test [template: test-buy-box] - start --*/
  const savePrice = computed(() => {
    if (!isSubscription.value) {
      const availableSubscriptionVariant = subscriptionVariants();
      if (availableSubscriptionVariant) {
        const { compare_at_price: compareAtPrice, price: subscriptionPrice } = availableSubscriptionVariant;
            return window.formattedPrice((compareAtPrice - subscriptionPrice)/100);
      } else {
        return null;
      }
    } else {
      var item = selectedVariant.value || product.value.variants[0]
      return item.compare_at_price > 0 ? window.formattedPrice(item.compare_at_price/100 - item.price/100) : null;
    }
  })
  /*-- Test [template: test-buy-box] - end --*/

  const compareAtPrice = computed(() => {
    var item = selectedVariant.value || product.value.variants[0]
    return item.compare_at_price > 0 ? window.formattedPrice(item.compare_at_price/100) : null;
  })

  const onetimePrice = computed(() => {
    const { variants } = product.value;
    var item = selectedVariant.value || variants[0];
    const { options } = item;

    const onetimeVariants = variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === 'One Time Purchase'
    );

    if (onetimeVariants.length > 0) {
      return window.formattedPrice(onetimeVariants[0].price/100)
    } else {
      return window.formattedPrice(item.price/100);
    }
  })

  const subscriptionPrice = computed(() => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];

    if (item.has_subscription_plan) {
      return getFormattedPrice(item.price, item.selling_plans);
    } else {
      const availableSubscriptionVariant = subscriptionVariants(item)

      if (availableSubscriptionVariant) {
        const sellingPlan = availableSubscriptionVariant.selling_plans[0];
        emit('update-selling-plan', {
          name: sellingPlan.selling_plan.name,
          id: sellingPlan.selling_plan.id,
          discount_type: sellingPlan.selling_plan.price_adjustments[0]?.value_type || '',
          discount_value: sellingPlan.selling_plan.price_adjustments[0]?.value || 0
        }, false);
        return getFormattedPrice(availableSubscriptionVariant.price, availableSubscriptionVariant.selling_plans);
      } else {
        return window.formattedPrice(0.00);
      }
    }
  })

  const multipackOptions = computed(() => {
    return product.value.options.map((option, optionIndex) => {
      return {
        ...option,
        values: option.values.filter((value) => isVariantOptionAvailable(optionIndex, value) && value.toLowerCase() !== 'one time purchase')
      };
    }).filter(option => isMultiPackOption(option));
  })

  const renderSubFrequency = computed(() => {
    if(!selectedVariant.value.has_subscription_plan) return null;

    const selectedVariantFrequencies = selectedVariant.value.selling_plans.map(plan => ({
      id: plan.selling_plan.id,
      name: plan.selling_plan.name,
      discount_type: plan.selling_plan.price_adjustments[0]?.value_type || '',
      discount_value: plan.selling_plan.price_adjustments[0]?.value || 0
    }));

    return selectedVariantFrequencies.filter(option => {
      if (isStayBundle.value) {
        return option.discount_value === 25;
      } else if (!isStayBundle.value) {
        return option.discount_value === 20;
      } else {
        return true;
      }
    });
  })

  const subscriptionVariants = (variant) => {
    const { variants } = product.value;
    const item = selectedVariant.value || variants[0];
    const { options } = item;

    return variants.find(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && 
      variant.options[options.length - 1] !== 'One Time Purchase' &&
      variant.selling_plans.length > 0
    );
  }

  const onSubscriptionChange = (value) => {
    const { variants } = product.value;
    const { options } = selectedVariant.value;
    const lastOptionIndex = options.length - 1;

    const filteredVariants = variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      )
    );

    if(value) {
      const subscriptionVariants = filteredVariants.filter(variant =>
        variant.options[lastOptionIndex] !== 'One Time Purchase' &&
        variant.has_subscription_plan
      );

      if (subscriptionVariants.length) {
        // Filter selling plans based on isStayBundle.value
        const filteredPlans = subscriptionVariants[0].selling_plans.filter(plan =>
          isStayBundle.value
            ? plan.selling_plan.price_adjustments[0].value === 25
            : plan.selling_plan.price_adjustments[0].value === 20
        );

        // Select the first matching plan or handle no matches
        if (filteredPlans.length > 0) {
          emit('update-option', product.value.options[lastOptionIndex].name, subscriptionVariants[0].options[lastOptionIndex], lastOptionIndex);
          emit('update-selling-plan', {
            id: filteredPlans[0].selling_plan.id,
            name: filteredPlans[0].selling_plan.name,
            discount_type: filteredPlans[0].selling_plan.price_adjustments[0].value_type,
            discount_value: filteredPlans[0].selling_plan.price_adjustments[0].value
          }, true);
        } else {
          // Handle case where no plans match (optional: fallback or skip emission)
          console.warn('No matching selling plans found for the given criteria.');
        }

        /*emit('update-option', product.value.options[lastOptionIndex].name ,subscriptionVariants[0].options[lastOptionIndex], lastOptionIndex);
        emit('update-selling-plan', {
          id: 'subscriptionVariants[0].selling_plans[0].selling_plan.id',
          name: subscriptionVariants[0].selling_plans[0].selling_plan.name,
          discount_type: subscriptionVariants[0].selling_plans[0].selling_plan.price_adjustments[0].value_type,
          discount_value: subscriptionVariants[0].selling_plans[0].selling_plan.price_adjustments[0].value
        }, true);*/
      }
    } else {
      const onetimeVariants = filteredVariants.filter(variant =>
        variant.options[lastOptionIndex] === 'One Time Purchase'
      );

      if(onetimeVariants.length) {
        emit('update-option',product.value.options[lastOptionIndex].name,onetimeVariants[0].options[lastOptionIndex], lastOptionIndex);
      }
    }

    isSubscription.value = value;
    emit('update-is-subscription', value)
  }

  const onSubscriptionOptionChange = (key,value,index) => {
    emit('update-option', key, value, index);
    setTimeout(() => {
      const planExists = renderSubFrequency.value.some(plan => plan.id === selectedSellingPlan.value.id);

      if (!planExists) {
        emit('update-selling-plan', renderSubFrequency.value[0], true);
      }
    })
  }

  const getDiscountPercentage = (variant) => {
    const { compare_at_price: compareAtPrice, price: subscriptionPrice, selling_plans: sellingPlans } = variant;
    const selectedSellingPlanDiscountValue = selectedSellingPlan?.value?.discount_value ?? null;
    const selectedSellingPlanDiscountType = selectedSellingPlan?.value?.discount_type ?? null;

    if (compareAtPrice <= 0 || (selectedSellingPlanDiscountValue > 0 && selectedSellingPlanDiscountType === 'percentage')) {
      const sellingPlan = sellingPlans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
      
      if(sellingPlan) {
        const { value_type: type, value } = sellingPlan.selling_plan.price_adjustments[0];
        return value;
      } else {
        return 0;
      }
    } else {
      return Math.round((compareAtPrice - subscriptionPrice) / compareAtPrice * 100);
    }
  };

  const getFormattedPrice = (price, sellingPlans) => {
    if (window.shopLocation !== 'GB' && isMultiPack.value) {
      return window.formattedPrice(price / 100);
    } else {
      const sellingPlan = sellingPlans.find(plan => plan.selling_plan.id === selectedSellingPlan.value.id);
      if (sellingPlan) {
        return window.formattedPrice((sellingPlan.per_delivery_price / 100).toFixed(2));
      }
      return window.formattedPrice((price / 100).toFixed(2));
    }
  }

  const isMultiPackOption = (option) => {
    return ['boxes', 'tubs', 'bottles'].includes(option.name.toLowerCase());
  };

  const isVariantOptionAvailable = (index, value) => {
    const { options } = selectedVariant.value;
    const { variants } = product.value;

    const optionsMap = [...options];
    optionsMap[index] = value;

    return variants.some(variant =>
      variant.options[0] === optionsMap[0] &&
      variant.options[1] === optionsMap[1] &&
      (index !== 2 || variant.options[2] === optionsMap[2])
    );
  };

  const getOptionUnitPrice = (value) => {
    const { variants } = product.value;
    var item = selectedVariant.value;
    const { options } = item;
    
    const availableSubscriptionVariant = variants.find(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === value
    );

    if (availableSubscriptionVariant) {
      let subscriptionPackSize = 1;
      const regex = /\d+/g;
      const packDigit = value.match(regex);

      if (packDigit.length) subscriptionPackSize = packDigit[0];

      return formattedPrice(parseInt(availableSubscriptionVariant.price / subscriptionPackSize) / 100);
    }
  };

  const multipackOptionTag = (position, value) => {
    var item = selectedVariant.value;
    const { options } = item;

    const availableVariants = product.value.variants.filter(variant =>
      options.slice(0, options.length - 1).every((option, index) =>
        variant.options[index] === option
      ) && variant.options[options.length - 1] === value
    );

    if (availableVariants.length > 0) {
      const discount = getDiscountPercentage(availableVariants[0]);
      const variant2Pack = availableVariants[0].title.toString().includes('2');
      const variant3Pack = availableVariants[0].title.toString().includes('3');

      if (variant2Pack && discount >= 22.5){
        return 'Best Seller';
      } else if (variant3Pack && discount >= 25) {
        return 'Best Value';
      }
    }
  }

  const toggleFrequencyDrpdwn = () => {
    isFrequencyDrpdwnOpen.value = !isFrequencyDrpdwnOpen.value;
  };

  defineExpose({isSubscription, isFrequencyDrpdwnOpen, onSubscriptionChange})
</script>